// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2023project/q4/2023light_disk_service_platform/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const getNews = (page: any, category: any, classId: any) => {
  return http.get(
    `/v1/news/topicList?page=${page}&classId=${classId}&category=${category}`,
  );
};

const getList = (page: number, keyword?: string) => {
  return http.get(`${urlPrefix}vote-list`, {
    params: {
      page,
      search: keyword,
    },
  });
};

const getRule = () => {
  return http.get(`${urlPrefix}rules`);
};

const getGold = () => {
  return http.get(`${urlPrefix}getGold`);
};

const getActivity = (page: number) => {
  return http.get(`${urlPrefix}getActivity`, {
    params: {
      page,
    },
  });
};

const getH5 = (page: number) => {
  return http.get(`${urlPrefix}getH5`, {
    params: {
      page,
    },
  });
};

const addPv = (id: number, type:number) => {
  return http.get(`${urlPrefix}addPv`, {
    params: {
      id,
      type,
    },
  });
}

const register = (data: any) => {
  return http.post(`${urlPrefix}save`, qs.stringify(data));
};

// 新闻
const TEST_API = 'https://t8-testapi-proxy.cqcb.com';
const PRO_API = 'https://t8-api-proxy.cqcb.com';

const getNewsList = (data: any) => {
  let path = '';
  if (process.env.VUE_APP_ENV_NAME === 'development') {
    path = '/wap/api/v1/newsListColumn';
  } else if (process.env.VUE_APP_ENV_NAME === 'TEST') {
    path = TEST_API + '/api/v1/newsListColumn';
  } else if (process.env.VUE_APP_ENV_NAME === 'production') {
    path = PRO_API + '/api/v1/newsListColumn';
  }
  return http.get(path, { params: data });
};

export { getBaseInfo, getNews, getList, register, getGold, getActivity, getH5, getRule, addPv, getNewsList };
